import { NgModule } from "@angular/core";
import { TourNgxBootstrapModule } from "ngx-ui-tour-ngx-bootstrap";
import { CommonTourComponent } from "./common-tour.component";

@NgModule({
    declarations: [
        CommonTourComponent
    ],
    imports: [
        TourNgxBootstrapModule,
    ],
    exports: [
        CommonTourComponent
    ],
    providers: [],
})
export class CommonTourModule { }  